import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { OwnerShare } from '@app/components/pr-form/pr-input-owner-share/pr-input-owner-share.component';
import { UtilsService } from '@app/providers/utils/utils.service';
import { EaEstateLoanFormService } from '../ea-estate-loan-form/ea-estate-loan-form.service';

@Injectable({
  providedIn: 'root',
})
export class EaScpiFormService {
  constructor(
    protected formBuilder: FormBuilder,
    protected utilsService: UtilsService,
    protected prFormService: PrFormService,
    protected eaEstateLoanFormService: EaEstateLoanFormService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};
    if (!entity) entity = {};

    let mainLoan: any = null;
    if (entity && entity.loans && entity.loans[0]) mainLoan = entity.loans[0];
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null, Validators.nullValidator],
        userId: [entity ? entity.userId : null, Validators.nullValidator],
        accountId: [entity ? entity.accountId : null, Validators.nullValidator],
        typeUrl: [entity ? entity.typeUrl : null, Validators.nullValidator],

        product: [
          entity ? entity.name : null,
          [Validators.required, this.prFormService.isObjectValidator],
        ],

        purchasePrice: [
          entity ? entity.purchasePrice : null,
          { validators: Validators.required },
        ],
        nbShare: [
          entity ? entity.nbShare : null,
          { validators: Validators.required },
        ],

        ownershipType: [
          entity ? entity.ownershipType : null,
          [
            Validators.required,
            this.prFormService.RefreshEveryValidators([
              'dismemberDuration',
              'dismemberKey',
            ]),
          ],
        ],
        dismemberDuration: [
          entity ? entity.dismemberDuration : null,
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo('ownershipType', [
                'NU_PROPRIO',
                'USUFRUIT',
              ])
              .bind(this),
            Validators.required,
          ),
        ],
        dismemberKey: [
          entity && entity.dismemberKey ? entity.dismemberKey * 100 : null,
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo('ownershipType', [
                'NU_PROPRIO',
                'USUFRUIT',
              ])
              .bind(this),
            Validators.required,
          ),
        ],

        owners: [entity ? entity.owners : null, Validators.required],
        startDate: [entity ? entity.startDate : null, Validators.required],
        subscriptionSource: [
          entity ? entity.subscriptionSource : null,
          Validators.required,
        ],

        loans: this.eaEstateLoanFormService.generate(
          mainLoan || { accountId: entity.accountId },
        ),
      },
      options,
    );
  }

  public extract(form: UntypedFormGroup, nestedForms?) {
    let dto = {
      id: this.utilsService.emptyIsNull(form.value.id),
      userId: this.utilsService.emptyIsNull(form.value.userId),
      accountId: this.utilsService.emptyIsNull(form.value.accountId),
      typeUrl: this.utilsService.emptyIsNull(form.value.typeUrl),
      type: 'REAL_ESTATE',

      name: this.utilsService.emptyIsNull(form.value.product.name),
      label: this.utilsService.emptyIsNull(form.value.product.name),
      productId: this.utilsService.emptyIsNull(form.value.product.id),
      removeLoan: false,
      purchasePrice: this.utilsService.emptyIsNull(form.value.purchasePrice),
      nbShare: this.utilsService.emptyIsNull(form.value.nbShare),
      subscriptionSource: this.utilsService.emptyIsNull(
        form.value.subscriptionSource,
      ),
      ownershipType: this.utilsService.emptyIsNull(form.value.ownershipType),
      dismemberDuration: this.utilsService.emptyIsNull(
        typeof form.value.dismemberDuration == 'number'
          ? Number(form.value.dismemberDuration)
          : form.value.dismemberDuration,
      ),
      dismemberKey: this.utilsService.emptyIsNull(
        form.value.dismemberKey ? form.value.dismemberKey / 100 : null,
      ),
      startDate: this.utilsService.toIsoDate(form.value.startDate),
      // Détenteurs + part de détention (`share`, fraction 0..1) saisis via
      // `<pr-input-owner-share>` : la valeur est déjà un `OwnerShare[]`.
      owners: ((form.value.owners || []) as OwnerShare[])
        .filter(o => o?.ownerId != null)
        .map(o => ({ ownerId: Number(o.ownerId), share: o.share })),
      loans: this.eaEstateLoanFormService.extract(
        form.get('loans') as FormGroup,
      ),
    };
    return dto;
  }
}
